// The app's "Trust this device" key (ART-317). After an emailed sign-in code with "Trust this device" ticked, the
// server hands the app a key; the next password sign-in sends it back and skips the code. The web never sees its
// key — it rides an httpOnly cookie the server sets — so on the web this is a no-op.
//
// Kept in the Keychain through the plugin the bearer already uses, one entry PER ADDRESS: two people sharing a phone
// each keep their own, and a key only ever works for the person it was minted for anyway. Deliberately NOT cleared by
// `TokenProvider.clear()`: signing out keeps the device trusted, which is what "trust this device" means.
import { Capacitor } from "@capacitor/core";
import { SecureStoragePlugin } from "capacitor-secure-storage-plugin";

const keyFor = (email: string) => `cntrl.trustedDevice.${email.trim().toLowerCase()}`;

export const trustedDevice = {
  /** The key this device holds for `email`, or null (web, never trusted, unreadable). Never rejects. */
  async get(email: string): Promise<string | null> {
    if (!Capacitor.isNativePlatform()) return null;
    try {
      const { value } = await SecureStoragePlugin.get({ key: keyFor(email) });
      return value || null;
    } catch {
      return null;
    }
  },

  /** Keep the key for `email`. Best effort: a failed write only means the code is asked for again next time. */
  async set(email: string, token: string): Promise<void> {
    if (!Capacitor.isNativePlatform()) return;
    try {
      await SecureStoragePlugin.set({ key: keyFor(email), value: token });
    } catch {
      // best effort
    }
  },
};
